import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

/**
 * Progresso da fila de e-mails de um envio (enviados, falhas e ignorados sobre o total).
 * @param {{ sends: { total, pending, sent, failed, skipped } }} props
 */
function EditionSendProgress({ sends = {} }) {
  const total = sends.total || 0;
  if (total === 0) return null;
  const done = (sends.sent || 0) + (sends.failed || 0) + (sends.skipped || 0);

  return (
    <Box sx={{ mt: 2 }}>
      <LinearProgress variant="determinate" value={Math.round((done / total) * 100)} sx={{ height: 6, borderRadius: 3 }} />
      <Typography variant="caption" color="text.secondary">
        {done} de {total} processados
        {sends.failed ? ` · ${sends.failed} falha(s)` : ''}
        {sends.pending ? ' · atualizando sozinho enquanto houver pendentes' : ''}
      </Typography>
    </Box>
  );
}

export default EditionSendProgress;
